import type { ReactNode } from 'react';
import { Box, Button, Stack } from '@mui/material';
import { Undo } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

interface SampleActionBarProps {
  onNewSample: () => void;
  onUndo?: () => void;
  onDelete: () => void;
  onCreateWorkOrder?: () => void;
  onUploadSample?: () => void;
  onGenerateRefs?: () => void;
  hasSelection: boolean;
  canUndo?: boolean;
  endSlot?: ReactNode;
  hideNewSample?: boolean;
  hideUploadSample?: boolean;
  hideGenerateRefs?: boolean;
  hideDelete?: boolean;
}

export const SampleActionBar = ({
  onNewSample,
  onUndo,
  onDelete,
  onCreateWorkOrder,
  onUploadSample,
  onGenerateRefs,
  hasSelection,
  canUndo = false,
  endSlot,
  hideNewSample = false,
  hideUploadSample = false,
  hideGenerateRefs = false,
  hideDelete = false,
}: SampleActionBarProps) => {
  const theme = useTheme();

  return (
    <Stack direction="row" alignItems="center" sx={{ mb: 1.5, gap: 1 }}>
      {!hideNewSample && (
        <Button
          variant="contained"
          size="small"
          onClick={onNewSample}
          sx={{
            backgroundColor: theme.customColors.maroon,
            '&:hover': { backgroundColor: '#6B1414' },
            textTransform: 'none',
            fontWeight: 600,
          }}
        >
          + New Sample
        </Button>
      )}
      {!hideUploadSample && (
        <Button variant="outlined" size="small" onClick={onUploadSample} sx={{ textTransform: 'none' }}>
          Upload Sample
        </Button>
      )}
      {onGenerateRefs && !hideGenerateRefs && (
        <Button variant="outlined" size="small" onClick={onGenerateRefs} sx={{ textTransform: 'none' }}>
          Generate Sample Refs
        </Button>
      )}
      <Button
        variant="outlined"
        size="small"
        disabled={!hasSelection}
        onClick={onCreateWorkOrder}
        sx={{ textTransform: 'none' }}
      >
        Create Work Order
      </Button>
      <Box sx={{ flex: 1 }} />
      {endSlot}
      <Button
        variant="outlined"
        size="small"
        disabled={!canUndo}
        onClick={onUndo}
        startIcon={<Undo sx={{ fontSize: 16 }} />}
        sx={{ textTransform: 'none', fontWeight: 600, minWidth: 70 }}
      >
        Undo
      </Button>
      {!hideDelete && (
        <Button
          variant="contained"
          size="small"
          color="error"
          disabled={!hasSelection}
          onClick={onDelete}
          sx={{ textTransform: 'none', fontWeight: 600, minWidth: 70 }}
        >
          Delete
        </Button>
      )}
    </Stack>
  );
};
